import { ApiError } from '../../lib/api'

/**
 * Link de e-mail/convite que não serve mais: a API responde 400 "Dados inválidos." quando o código do link
 * está malformado (campo `token`), 404/410 quando não existe ou expirou. Em todos os casos o caminho é pedir outro link.
 */
export function isDeadLink(err: unknown): boolean {
  if (!(err instanceof ApiError)) return false
  if (err.status === 404 || err.status === 410) return true
  if (err.code !== 'validation' || !Array.isArray(err.details)) return false
  return err.details.some((d) => typeof d === 'object' && d !== null && String((d as { instancePath?: unknown }).instancePath ?? '').includes('token'))
}

/** Mensagem humana: troca o "Dados inválidos." de um link malformado por `fallback`; as demais mensagens da API já são claras. */
export function linkErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError && err.code === 'validation' && isDeadLink(err)) return fallback
  return err instanceof Error ? err.message : fallback
}

/** Falha de rede ou do servidor: tentar de novo pode resolver (diferente de um link morto). */
export const isTransient = (err: unknown) => err instanceof ApiError && (err.status === 0 || err.status >= 500)
